import Types from './Types';
/* eslint-disable camelcase */

/************************************************
Get invoices details
*************************************************/

const getInvoices = (query) =>{
   return ({ type: Types.GET_INVOICES, query })};

const getInvoicesSuccess = (invoices) => ({ type: Types.GET_INVOICES_SUCCESS, invoices });

const getInvoicesFailure = (error) => ({
    type: Types.GET_INVOICES_FAILURE,
    error,
});

/************************************************
Get invoices noon details
*************************************************/

const getInvoicesNoon = (query) =>{
   return ({ type: Types.GET_INVOICES_NOON, query })};

const getInvoicesNoonSuccess = (invoices) => ({ type: Types.GET_INVOICES_NOON_SUCCESS, invoices });

const getInvoicesNoonFailure = (error) => ({
    type: Types.GET_INVOICES_NOON_FAILURE,
    error,
});

/************************************************
Get payments details
*************************************************/

const getPayments = (query) =>{
   return ({ type: Types.GET_PAYMENTS, query })};

const getPaymentsSuccess = (payments) => ({ type: Types.GET_PAYMENTS_SUCCESS, payments });

const getPaymentsFailure = (error) => ({
    type: Types.GET_PAYMENTS_FAILURE,
    error,
});

/************************************************
Get credit notes data
*************************************************/

const getCreditNotes = (query) =>{
   return ({ type: Types.GET_CREDIT_NOTES, query })};

const getCreditNotesSuccess = (creditNotes) => ({ type: Types.GET_CREDIT_NOTES_SUCCESS, creditNotes });

const getCreditNotesFailure = (error) => ({
    type: Types.GET_CREDIT_NOTES_FAILURE,
    error,
});

/************************************************
Get payment details
*************************************************/

const getPaymentDetails = (query) =>{
   return ({ type: Types.GET_PAYMENT_DETAILS, query })};

const getPaymentDetailsSuccess = (payments) => ({ type: Types.GET_PAYMENT_DETAILS_SUCCESS, payments });

const getPaymentDetailsFailure = (error) => ({
    type: Types.GET_PAYMENT_DETAILS_FAILURE,
    error,
});

/************************************************
Get finance details
*************************************************/

const getFinanceView = (query) =>{
   return ({ type: Types.GET_FINANCE_VIEW, query })};

const getFinanceViewSuccess = (finance) => ({ type: Types.GET_FINANCE_VIEW_SUCCESS, finance });

const getFinanceViewFailure = (error) => ({
    type: Types.GET_FINANCE_VIEW_FAILURE,
    error,
});

/************************************************
Get Order details
*************************************************/

const getOrderView = (query) =>{
   return ({ type: Types.GET_ORDER_VIEW, query })};

const getOrderViewSuccess = (order) => ({ type: Types.GET_ORDER_VIEW_SUCCESS, order });

const getOrderViewFailure = (error) => ({
    type: Types.GET_ORDER_VIEW_FAILURE,
    error,
});

/************************************************
Export Invoice
*************************************************/

const exportInvoice = (query) =>{
   return ({ type: Types.EXPORT_INVOICE, query })};

const exportInvoiceSuccess = (invoice) => ({ type: Types.EXPORT_INVOICE_SUCCESS, invoice });

const exportInvoiceFailure = (error) => ({
    type: Types.EXPORT_INVOICE_FAILURE,
    error,
});

/************************************************
Export CreditNote
*************************************************/

const exportCreditNote = (query) =>{
   return ({ type: Types.EXPORT_CREDIT_NOTE, query })};

const exportCreditNoteSuccess = (invoice) => ({ type: Types.EXPORT_CREDIT_NOTE_SUCCESS, invoice });

const exportCreditNoteFailure = (error) => ({
    type: Types.EXPORT_CREDIT_NOTE_FAILURE,
    error,
});

/************************************************
Export statements
*************************************************/

const exportStatements = (query) =>{
   return ({ type: Types.EXPORT_STATEMENTS, query })};

const exportStatementsSuccess = (invoice) => ({ type: Types.EXPORT_STATEMENTS_SUCCESS, invoice });

const exportStatementsFailure = (error) => ({
    type: Types.EXPORT_STATEMENTS_FAILURE,
    error,
});

export {
    getInvoices,
    getInvoicesSuccess,
    getInvoicesFailure,
    getInvoicesNoon,
    getInvoicesNoonSuccess,
    getInvoicesNoonFailure,
    getCreditNotes,
    getCreditNotesSuccess,
    getCreditNotesFailure,
    getPayments,
    getPaymentsSuccess,
    getPaymentsFailure,
    getPaymentDetails,
    getPaymentDetailsSuccess,
    getPaymentDetailsFailure,
    getFinanceView,
    getFinanceViewSuccess,
    getFinanceViewFailure,
    getOrderView,
    getOrderViewSuccess,
    getOrderViewFailure,
    exportCreditNote,
    exportCreditNoteSuccess,
    exportCreditNoteFailure,
    exportInvoice,
    exportInvoiceSuccess,
    exportInvoiceFailure,
    exportStatements,
    exportStatementsSuccess,
    exportStatementsFailure,
};



// WEBPACK FOOTER //
// ./src/actions/StatementsActions.js